<ada-card
	#BlacklistPropertiesCard
	id="BlacklistPropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Blacklist Properties"
		data-container-selector="ada-card-header"
		id="GeneralPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<ng-container *ngIf="'On' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#OnLabel
				id="OnLabel"
				[content]="'On'"
				[isDisabled]="isDisabled"
				[isRequired]="'On' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-toggle-switch
				#OnInput
				id="OnInput"
				[isDisabled]="true"
				[isToggled]="currentPropertyObject?.On"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			/>
		</ng-container>
		<ng-container *ngIf="'Hidden' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#HiddenLabel
				id="HiddenLabel"
				[content]="'Hidden'"
				[isDisabled]="isDisabled"
				[isRequired]="'Hidden' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-toggle-switch
				#HiddenInput
				id="HiddenInput"
				[isDisabled]="true"
				[isToggled]="currentPropertyObject?.Hidden"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			/>
		</ng-container>
		<ng-container *ngIf="'Reason' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#ReasonLabel
				id="ReasonLabel"
				[content]="'Reason'"
				[inheriting]="currentPropertyObject?.Reason | inheritPipe: inheritedPropertyObject?.Reason"
				[isDisabled]="isDisabled"
				[isRequired]="'Reason' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-input
				#ReasonInput
				id="ReasonInput"
				minHeight="8rem"
				[isReadOnly]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[type]="'textarea'"
				[value]="currentPropertyObject?.Reason"
			/>
		</ng-container>
		<ng-container *ngIf="'VendorUrl' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#VendorUrlLabel
				id="VendorUrlLabel"
				[content]="'VendorUrl'"
				[inheriting]="currentPropertyObject?.VendorUrl | inheritPipe: inheritedPropertyObject?.VendorUrl"
				[isDisabled]="isDisabled"
				[isRequired]="'VendorUrl' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-hyperlink
				color="primary"
				text="{{ currentPropertyObject?.VendorUrl || '--' }}"
				[external]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[route]="currentPropertyObject?.VendorUrl"
			/>
		</ng-container>
	</ada-container>
</ada-card>
